import { ApiEndpointsVault, instanceVault, VaultCardType } from 'src/services/Vault/client';
import { ConfirmOfferType, CreateOfferType, UpdateOfferType } from 'store/slices/vault/types';

class VaultService {
  static async getVaultProfileData() {
    return instanceVault.get(ApiEndpointsVault.profileData);
  }

  static async getVaultWallets() {
    return instanceVault.get(ApiEndpointsVault.getWallets);
  }

  static async getVaultTransactionHistory() {
    return instanceVault.get(ApiEndpointsVault.getHistory);
  }

  static async addCard(data: VaultCardType) {
    return instanceVault.post(ApiEndpointsVault.payIn, data);
  }

  static async getVaultCardsData() {
    return instanceVault.get(ApiEndpointsVault.cardsData);
  }

  static async createOffer(data: CreateOfferType) {
    return instanceVault.post(ApiEndpointsVault.createOffer, data);
  }

  static async updateOffer(data: UpdateOfferType) {
    const { offerId: id } = data;
    return instanceVault.put(`${ApiEndpointsVault.createOffer}/${id}`, data);
  }

  static async confirmOffer(data: ConfirmOfferType) {
    const { offerId: id } = data;
    return instanceVault.post(`${ApiEndpointsVault.confirmOffer}${id}`, data);
  }

  static async getPayInStatus(id: number) {
    return instanceVault.get(`${ApiEndpointsVault.payInStatus}?offerId=${id}`);
  }
}

export default VaultService;
